import nodule21 from "./nodule2-1";
import nodule22 from "./nodule2-2";
import nodule23 from "./nodule2-3";
import nodule24 from "./nodule2-4";
import nodule25 from "./nodule2-5";
import nodule26 from "./nodule2-6";
import nodule27 from "./nodule2-7";
import nodule28 from "./nodule2-8";
import nodule29 from "./nodule2-9";
import nodule210 from "./nodule2-10";
import nodule211 from "./nodule2-11";
import nodule212 from "./nodule2-12";

export default [
  nodule21,
  nodule22,
  nodule23,
  nodule24,
  nodule25,
  nodule26,
  nodule27,
  nodule28,
  nodule29,
  nodule210,
  nodule211,
  nodule212,
];
